import { Fab, useTheme } from '@mui/material';
import { generatePath, Link } from 'react-router-dom';
import { paths } from '../../routing/Router/paths';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useGlobalBrandKey } from '../../utils/globalState';

export const SpeedDialGoodDealArticleIA = () => {
  const theme = useTheme();
  const [brandKey] = useGlobalBrandKey();

  if (!brandKey) {
    return null;
  }

  return (
    <Link to={generatePath(paths.ARTICLE_IA, { brandKey })}>
      <Fab
        color="primary"
        sx={{
          position: 'fixed',
          bottom: theme.spacing(12),
          right: theme.spacing(3),
          zIndex: 1,
          bgcolor: '#4a62f4',
        }}
      >
        <AutoFixHighIcon />
      </Fab>
    </Link>
  );
};
